import { message } from 'antd';

export async function copyText(text) {
    try {
        await navigator.clipboard.writeText(text);
        message.success('Copied to clipboard.');
    } catch {
        message.error('Could not copy automatically. Select the text and copy it manually.');
    }
}
